import { JOBS_URL } from '@/utils/constants'

const SERVICES = () => JOBS_URL
const SERVICE_BY_ID = (id: string) => `${JOBS_URL}/${id}`

export default {
  SERVICES,
  SERVICE_BY_ID
}
